module.exports = __webpack_public_path__ + "static/img/13.4164704.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/13.png
// module id = gkiA
// module chunks = 0